<template>
    <icon-base v-bind="$props">
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"></path>
        <path d="M12 9h.01"></path>
        <path d="M11 12h1v4h1"></path>
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
